import { useEffect, useState } from 'react';
import { adoptSession, dropSession, studioApi } from '@/lib/studioApi';

let current, pending;
const listeners = new Set();
const publish = value => { current = value; listeners.forEach(fn => fn(value)); window.dispatchEvent(new Event('account-changed')); };

export const loadAccount = (force = false) => {
  if (!force && current !== undefined) return Promise.resolve(current);
  if (!pending) pending = studioApi('/account/me').then(d => { current = d.account; listeners.forEach(fn => fn(current)); return current; }).catch(() => null).finally(() => { pending = null; });
  return pending;
};

window.addEventListener('studio-session-reset', () => { if (current) loadAccount(true).then(a => publish(a)); });

export const useAccount = () => {
  const [account, setAccount] = useState(current);
  useEffect(() => { listeners.add(setAccount); loadAccount().then(setAccount); return () => listeners.delete(setAccount); }, []);
  return account;
};

const enter = async (path, body) => { const data = await studioApi(path, { method: 'POST', body }); adoptSession(data); publish(data.account); return data.account; };
export const login = body => enter('/account/login', body);
export const register = body => enter('/account/register', body);
export const logout = async () => { await studioApi('/account/logout', { method: 'POST' }).catch(() => {}); dropSession(); publish(null); };
